export class SelectOption {
  constructor(
    public id: any,
    public value: string,
    public i18n?: string,
    public group?: Array<SelectOption>,
    public disabled?: boolean
  ) { }
}
